import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
import NotAuthorized from '../components/GeneralViews/NotAuthorized.vue'
import LogIn from '../components/GeneralViews/LogIn.vue'
import UserRecovery from '../components/GeneralViews/UserRecovery.vue'
import PasswordReset from '../components/GeneralViews/PasswordReset.vue'

// Dashboard pages
import Setting from 'src/components/Dashboard/Views/Setting.vue'
import DipendenteList from 'src/components/Dashboard/Views/DipendenteList.vue'
import Dipendente from 'src/components/Dashboard/Views/Dipendente.vue'
import LavorazioneList from 'src/components/Dashboard/Views/LavorazioneList.vue'
import Lavorazione from 'src/components/Dashboard/Views/Lavorazione.vue'
import Home from 'src/components/Dashboard/Views/Home.vue'
import OreLavoro from 'src/components/Dashboard/Views/OreLavoro.vue'
import RiepilogoCompensi from 'src/components/Dashboard/Views/RiepilogoCompensi.vue'
import Trattamenti from 'src/components/Dashboard/Views/Trattamenti.vue'
import RiepilogoTrattamenti from 'src/components/Dashboard/Views/RiepilogoTrattamenti.vue'
import FarmacoList from 'src/components/Dashboard/Views/FarmacoList.vue'
import Farmaco from 'src/components/Dashboard/Views/Farmaco.vue'
import OrtaggioList from 'src/components/Dashboard/Views/OrtaggioList.vue'
import Ortaggio from 'src/components/Dashboard/Views/Ortaggio.vue'

import Overview from 'src/components/Dashboard/OldViews/Overview.vue'
import Typography from 'src/components/Dashboard/OldViews/Typography.vue'
import Maps from 'src/components/Dashboard/OldViews/Maps.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard/home'
  },
  {
    path: '/dashboard',
    component: DashboardLayout,
    redirect: '/dashboard/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'ore-lavoro',
        name: 'Ore di lavoro',
        component: OreLavoro,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'riepilogo-compensi',
        name: 'Riepilogo compensi',
        component: RiepilogoCompensi,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'trattamenti',
        name: 'Trattamenti',
        component: Trattamenti,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'riepilogo-trattamenti',
        name: 'Riepilogo trattamenti',
        component: RiepilogoTrattamenti,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'dipendente-list',
        name: 'Elenco dipendenti',
        component: DipendenteList,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: ':pattern'
          }
        ]
      },
      {
        path: 'dipendente-new',
        name: 'Nuovo dipendente',
        component: Dipendente,
        meta: {
          requiresAuth: true,
          new: true
        }
      },
      {
        path: 'dipendente/:id',
        name: 'Dipendente',
        component: Dipendente,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'lavorazione-list',
        name: 'Elenco lavorazioni',
        component: LavorazioneList,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: ':pattern'
          }
        ]
      },
      {
        path: 'lavorazione-new',
        name: 'Nuova lavorazione',
        component: Lavorazione,
        meta: {
          requiresAuth: true,
          new: true
        }
      },
      {
        path: 'lavorazione/:id',
        name: 'Lavorazione',
        component: Lavorazione,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'ortaggio-list',
        name: 'Elenco ortaggi',
        component: OrtaggioList,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: ':pattern'
          }
        ]
      },
      {
        path: 'ortaggio-new',
        name: 'Nuovo ortaggio',
        component: Ortaggio,
        meta: {
          requiresAuth: true,
          new: true
        }
      },
      {
        path: 'ortaggio/:id',
        name: 'Ortaggio',
        component: Ortaggio,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'setting',
        name: 'Impostazioni',
        component: Setting,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'farmaco-list',
        name: 'Elenco farmaci',
        component: FarmacoList,
        meta: {
          requiresAuth: true
        },
        children: [
          {
            path: ':pattern'
          }
        ]
      },
      {
        path: 'farmaco-new',
        name: 'Nuovo farmaco',
        component: Farmaco,
        meta: {
          requiresAuth: true,
          new: true
        }
      },
      {
        path: 'farmaco/:id',
        name: 'Farmaco',
        component: Farmaco,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        meta: {
          requiresAuthType: ['A']
        }
      },
      {
        path: 'typography',
        name: 'Typography',
        component: Typography,
        meta: {
          requiresAuthType: ['A']
        }
      },
      {
        path: 'maps',
        name: 'Maps',
        component: Maps,
        meta: {
          requiresAuthType: ['A']
        }
      }
    ]
  },
  {
    path: '/',
    component: DashboardLayout,
    children: [
      {
        path: 'login',
        component: LogIn
      },
      {
        path: 'user-recovery',
        component: UserRecovery
      },
      {
        path: 'password-reset',
        component: PasswordReset
      },
      {
        path: 'notauthorized',
        component: NotAuthorized
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js